<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<mat-form-field class="chip-list" [class.has-chips]="selectedElements.length > 0" appearance="outline" floatLabel="always" [subscriptSizing]="subscriptSizing">
  <mat-label>{{ title }}</mat-label>
  <mat-chip-grid #chipGrid>
    @for (element of selectedElements; track element) {
    <mat-chip-row (removed)="remove(element)" (click)="onChipClick(element)">
      {{ element.name }}
      <button matChipRemove [attr.aria-label]="'remove ' + element.name">
        <fa-icon class="icon chip-remove-icon" [icon]="faXmark"></fa-icon>
      </button>
    </mat-chip-row>
    }
  </mat-chip-grid>
  <input
    [placeholder]="inputPlaceholder"
    #elementsInput
    [formControl]="control"
    [matChipInputFor]="chipGrid"
    [matAutocomplete]="auto"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
  />
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="select($event.option.value)">
    @for (element of filteredElements ; track element) {
    <mat-option [value]="element">{{ element.name }}</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
